import React, { useState, useEffect } from 'react';
import { Table, Space, Divider, Popover, Checkbox, Button } from 'antd';
import { ReloadOutlined, SettingOutlined, FullscreenOutlined } from '@ant-design/icons';
import styles from './index.module.less';

function Footer(props) {
  const actions = props.actions || [];
  const length = props.selected.length;
  return length > 0 ? (
    <div className={styles.tableFooter}>
      <div className={styles.left}>已选择 <span>{length}</span> 项</div>
      <Space size="middle">
        {actions.map((item, index) => (
          <React.Fragment key={index}>{item}</React.Fragment>
        ))}
      </Space>
    </div>
  ) : null
}

function TableCard(props) {
  const columns = props.columns || [];
  const actions = props.actions || [];
  const batchActions = props.batchActions || [];
  const rowSelection = props.rowSelection ? {onChange: handleSelect} : undefined;
  const [defaultFields, setDefaultFields] = useState([]);
  const [fields, setFields] = useState([]);
  const [checkAll, setCheckAll] = useState(false);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    const data = [];
    for (let [index, item] of columns.entries()) {
      if (!item.hide) data.push(index)
    }
    setDefaultFields(data);
    setFields(data)
  }, [columns])

  const Fields = () => {
    return (
      <Checkbox.Group value={fields} onChange={handleCheck}>
        {columns.map((item, index) => (
          <Checkbox value={index} key={index}>{item.title}</Checkbox>
        ))}
      </Checkbox.Group>
    )
  }

  function handleCheck(v) {
    setFields(v);
    if (v.length === 0) {
      setCheckAll(false)
    } else if (v.length === columns.length) {
      setCheckAll(true)
    }
  }

  function handleCheckAll(e) {
    if (e.target.checked) {
      setCheckAll(true);
      setFields(columns.map((_, index) => index))
    } else {
      setCheckAll(false);
      setFields([])
    }
  }

  function handleSelect(keys, rows) {
    setSelected(keys);
    if (props.rowSelection.onChange) {
      props.rowSelection.onChange(keys, rows)
    }
  }

  return (
    <div className={styles.tableCard}>
      <div className={styles.toolbar}>
        <div className={styles.title}>{props.title}</div>
        <div className={styles.option}>
          <Space size="middle">
            {actions.map((item, index) => (
              <React.Fragment key={index}>{item}</React.Fragment>
            ))}
          </Space>
          {actions.length ? <Divider type="vertical"/> : null}
          <Space>
            <ReloadOutlined onClick={props.onReload}/>
            <Popover
              arrowPointAtCenter
              title={[
                <Checkbox
                  key="1"
                  checked={checkAll}
                  indeterminate={![0, columns.length].includes(fields.length)}
                  onChange={handleCheckAll}>列展示</Checkbox>,
                <Button key="2" type="link" style={{padding: 0}} onClick={() => setFields(defaultFields)}>重置</Button>
              ]}
              overlayClassName={styles.tableFields}
              trigger="click"
              placement="bottomRight"
              content={<Fields/>}>
              <SettingOutlined/>
            </Popover>
            <FullscreenOutlined/>
          </Space>
        </div>
      </div>
      <Table
        rowKey={props.rowKey}
        loading={props.loading}
        columns={columns.filter((_, index) => fields.includes(index))}
        dataSource={props.dataSource}
        rowSelection={rowSelection}
        pagination={props.pagination}/>
      <Footer selected={selected} actions={batchActions}/>
    </div>
  )
}

TableCard.Footer = Footer;
export default TableCard